export const updateLinksToOpenInNewTabs = (html: string | null) => {
  if (!html) return "";
  if (typeof window === "undefined") return html;

  const el = document.createElement("div");
  // nosemgrep
  el.innerHTML = html;
  [...el.getElementsByTagName("a")].forEach((link) => {
    link.setAttribute("rel", "noopener noreferrer");
    link.setAttribute("target", "_blank");
    link.setAttribute("class", "new-tab-link");
  });

  // nosemgrep
  return el.innerHTML;
};
